"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _getPropSelector = _interopRequireDefault(require("./getPropSelector"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// These are the props accepted specifically on React Native (Web) `Text` elements.
// They are generally concerned with the behaviour of multiline text.

const crossPlatform = {
  /**
   * Truncates text after this many lines with an ellipsis at the end.
   * On native, ellipsis behaviour may be changed with `ellipsizeMode` prop.
   */
  numberOfLines: _propTypes.default.number,
  /**
   * Default is true on web and false on native
   */
  selectable: _propTypes.default.bool
};

/**
 * See React Native docs for latest details on these.
 * https://reactnative.dev/docs/text
 */
const nativeOnly = {
  ellipsizeMode: _propTypes.default.string,
  maxFontSizeMultiplier: _propTypes.default.number,
  minimumFontScale: _propTypes.default.number,
  onTextLayout: _propTypes.default.func,
  suppressHighlighting: _propTypes.default.bool,
  textBreakStrategy: _propTypes.default.string
};

/**
 * These set HTML attributes of the same name.
 */
const webOnly = {
  dir: _propTypes.default.oneOf(['auto', 'ltr', 'rtl']),
  lang: _propTypes.default.string
};
var _default = exports.default = {
  /**
   * Set of prop types specific to React Native and React Native Web `Text`,
   * which largely revolve around the behaviour of multiline non-pressable text.
   */
  types: {
    ...crossPlatform,
    ...webOnly,
    ...nativeOnly
  },
  /**
   * Filters a props object, returning only props specific to `Text` elements
   * on the current platform. Does not include props applicable to `Text` and `View`.
   */
  select: (0, _getPropSelector.default)({
    ...crossPlatform,
    ..._Platform.default.select({
      web: webOnly,
      default: nativeOnly
    })
  })
};